import axios from "axios";
import { getBaseURLforBackEnd  , getConfigAxios , myTimeZone } from '@/utils.js'
import moment from 'moment-timezone' 
// import {getDecodeFromBase64ToHtml} from '../../mixins/methods/getDecodeFromBase64ToHtml'


export default {
    namespaced: true,
    state: {
        dateWantToSeeImagesOfMonth : new Date(),
        dateLoadedImagesOfMonth :  null,
        arrImagesOfMonth : [],
        firstImagesOfMonth : 100,
        skipImagesOfMonth : 0,
    },

    getters: {
    },

    mutations: {
        setDateLoadedImagesOfMonth (state, dateLoadedImagesOfMonth ) {
            state.dateLoadedImagesOfMonth  = dateLoadedImagesOfMonth
        },

        setFirstImagesOfMonth (state, firstImagesOfMonth ) {
            state.firstImagesOfMonth  = firstImagesOfMonth
        },

        setSkipImagesOfMonth (state, skipImagesOfMonth ) {
            state.skipImagesOfMonth  = skipImagesOfMonth
        },



        setDateWantToSeeImagesOfMonth (state, dateWantToSeeImagesOfMonth ) {
            state.dateWantToSeeImagesOfMonth  = dateWantToSeeImagesOfMonth
        },

        setArrImagesOfMonthToZero (state ,data ) {
            state.arrImagesOfMonth  = data
        },


        setArrImagesOfMonth (state, data ) {
            state.arrImagesOfMonth  = state.arrImagesOfMonth.concat(data)
        },


    },

    actions: {
    
        fetchArrImagesOfMonth({commit,state}) {
            const date_selected =  moment.tz(   state.dateWantToSeeImagesOfMonth , myTimeZone).format('YYYY-MM-DD') +'T00:00:00.000Z'
            // const datTo = {
            //     "date_want_to_see" : date_selected 
            // }
            const datTo = {
                "date_want_to_see" : date_selected,
                "first" : state.firstImagesOfMonth,
                "skip" : state.skipImagesOfMonth
            }
            // console.log('datTo--->',datTo)
            return new Promise((resolve,reject) => {
                axios.post(`${getBaseURLforBackEnd()}/api/listimageofmonth`,datTo,getConfigAxios())
                    .then((res)=>{
                        // Buffer.from(res.data.dat_prepare.dat, 'base64').toString('utf-8') 
                        // const o3 = {...o1, a: "updated a"};
                        // const tmp = {...res.data, a: "updated a"};
                        // console.log('res.data --->',res.data)

                        const tmp = res.data.map(dat=>{
                            
                            dat.dx.forEach(datDx=>{
                                // console.log('datDx---> ',datDx)
                                 datDx.comment_txt= datDx.comment_txt  ?  Buffer.from(datDx.comment_txt, 'base64').toString('utf-8')   : null
                                 datDx.unclassified_codes= datDx.unclassified_codes  ?   Buffer.from(datDx.unclassified_codes, 'base64').toString('utf-8')  : null
                                 datDx.dx_code= datDx.dx_code  ?  Buffer.from(datDx.dx_code, 'base64').toString('utf-8') : null
                            })   
                            return dat
                        })

                        // console.log(tmp)

                        commit('setArrImagesOfMonth', tmp )
                        //
                        commit('setDateLoadedImagesOfMonth', state.dateWantToSeeImagesOfMonth )
                        resolve(res.data)
                    })
                    .catch((err) =>{
                        reject(err)
                    })
            })
        },



    }
}